import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ScriptResultDialogComponent } from './dialogs/script-result-dialog/script-result-dialog.component'
import { DynamicDialogModule } from 'primeng/dynamicdialog'
import { DashboardPreviewDialogComponent } from './dialogs/dashboard-preview-dialog/dashboard-preview-dialog.component'
import { DtoModule } from '../dto/dto.module'

@NgModule({
  declarations: [ScriptResultDialogComponent, DashboardPreviewDialogComponent],
  imports: [CommonModule, DynamicDialogModule, DtoModule]
})
export class ActionModule {}
